// window.PRY — Prybar L tool map. 11 positions, all on face A (through-cuts and edge features).
// mx/my = millimetres on face A (mx from its left edge, my from its top), measured off https://mrf.tools/cdn/shop/files/mrf26-pry.stl?v=b3.
// The wrench cascade came out 7.97 / 9.56 / 11.16 / 12.75 mm — clean SAE, not metric.
window.PRY = {
  blocks: [
    { label: 'ENDS', tools: [
      { n: 1, side: 'A', mx: 3.1, my: 100, est: false, name: 'Flat screwdriver', cat: 'DRIVE',
        desc: 'The top end is left flat and 11 mm wide, backed by the full 5 mm slab.',
        sc: 'Paint lids, battery covers, staples — the wide tip spreads the load instead of chewing the screw.' },
      { n: 2, side: 'A', mx: 21.1, my: 100, est: false, name: 'Pry tip', cat: 'PRY',
        desc: 'A 30 mm taper bevelled on both faces down to the working edge.',
        sc: 'Load the whole bar, not the tip: with 100 mm of handle it lifts a stuck window sash.' },
      { n: 3, side: 'A', mx: 13, my: 100, est: false, name: 'Nail slot', cat: 'PRY',
        desc: 'A 1.2 mm slot between the two prongs of the pry end.',
        sc: 'Hook the nail head, roll the bar sideways — the prongs keep it from slipping off.' }
    ] },
    { label: 'DRIVE & OPEN', tools: [
      { n: 4, side: 'A', mx: 13.2, my: 7.2, est: false, name: '1/4 in bit driver', cat: 'DRIVE',
        desc: 'Hex socket through the head for any standard 1/4 in bit.',
        sc: 'Drop a bit in, hold it with the band, and the bar becomes a stubby driver with real torque.' },
      { n: 5, side: 'A', mx: 11.2, my: 44.3, est: false, name: 'Bit lock slot', cat: 'DRIVE',
        desc: 'The slot under the socket takes the silicone retaining band.',
        sc: 'The band is what keeps the bit in the head when the bar goes back in a pocket.' },
      { n: 6, side: 'A', mx: 0, my: 26.3, est: false, name: 'Bottle opener', cat: 'EVERYDAY',
        desc: 'A machined lip on the side of the head.',
        sc: 'Hook the crown, press with one finger — the leverage is in the curve.' },
      { n: 7, side: 'A', mx: 1.6, my: 31.9, est: false, name: 'Cord cutter', cat: 'EVERYDAY',
        desc: 'Notches cut into both long edges, mid-body.',
        sc: 'Pull paracord or zip ties through the notch; nothing here counts as a blade at security.' }
    ] },
    { label: 'SAE CASCADE', tools: [
      { n: 8, side: 'A', mx: 11, my: 69.3, est: false, name: '1/2 in wrench', cat: 'WRENCH',
        desc: 'Widest step of the cascade — 12.70 mm across flats.', sc: 'The common SAE bolt head in a garage.' },
      { n: 9, side: 'A', mx: 11.5, my: 61.5, est: false, name: '7/16 in wrench', cat: 'WRENCH',
        desc: 'Second step — 11.11 mm across flats.', sc: 'Small engine and mower hardware.' },
      { n: 10, side: 'A', mx: 11.3, my: 56.2, est: false, name: '3/8 in wrench', cat: 'WRENCH',
        desc: 'Third step — 9.53 mm across flats.', sc: 'Appliance and HVAC service nuts.' },
      { n: 11, side: 'A', mx: 11, my: 50.1, est: false, name: '5/16 in wrench', cat: 'WRENCH',
        desc: 'Narrowest step — 7.94 mm across flats.', sc: 'Sheet-metal screws and hose clamps.' }
    ] }
  ]
};
